module.exports = __WEBPACK_EXTERNAL_MODULE_214__;


//////////////////
// WEBPACK FOOTER
// external "gemini/lib/@waca/dashboard-common/dist/utils/EventChainLocal"
// module id = 214
// module chunks = 0